import type { HotelConfigResponse, UpsertHotelConfigRequest } from '@jq4race/shared';

import { request } from './client.js';

export async function getHotelConfig(locationId: string): Promise<HotelConfigResponse> {
  return request<HotelConfigResponse>(
    `/admin/locations/${encodeURIComponent(locationId)}/hotel-config`,
    { method: 'GET' },
  );
}

export async function upsertHotelConfig(
  locationId: string,
  input: UpsertHotelConfigRequest,
): Promise<HotelConfigResponse> {
  return request<HotelConfigResponse>(
    `/admin/locations/${encodeURIComponent(locationId)}/hotel-config`,
    { method: 'PUT', body: input },
  );
}
